import { ChangeEvent } from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { useStyles } from './styles'

interface ISeparationMethodFilterProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

const SeparationMethodFilter = ({ value, onChange, disabled = false }: ISeparationMethodFilterProps) => {
  const classes = useStyles()
  const options = [
    { field: 'Todos', value: '' },
    { field: 'Câmera', value: 'camera' },
    { field: 'Scanner', value: 'scanner' },
    { field: 'Manual', value: 'manual' }
  ]

  const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as string)
  }

  return (
    <FormControl 
      variant="outlined" 
      size="small" 
      className={classes.formControl}
    >
      <InputLabel id="separation-method-select-label">Método de separação</InputLabel>
      <Select
        labelId="separation-method-select-label"
        value={value}
        onChange={handleChange}
        label="Método de separação"
        style={{ 
          background: '#fff'
        }}
        disabled={disabled}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.field}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SeparationMethodFilter
